import { useTranslation } from 'react-i18next';
import styles from './Admin.module.css';
import { ReleaseDownloads } from './ReleaseDownloads.tsx';

/** The latest client release as users get it. Uploading is done by CI only, so there is no form. */
export function ReleasesPage() {
  const { t } = useTranslation('admin');
  return (
    <div className={styles['page']}>
      <h1 className={styles['heading']}>{t('releases.title')}</h1>
      <p className={styles['muted']}>{t('releases.intro')}</p>
      <div className={styles['card']}>
        <ReleaseDownloads />
      </div>
    </div>
  );
}
